module.exports = __webpack_public_path__ + "static/media/29EUNOG19.b1715c4a.jpg";